import ProductHelpers from '../product/base';
import init from '../giftcard/giftcard';
import Coupon from '../components/coupon';
import { paypalUtilsInit, paypalMFRAInit } from './paypal';
import Klarna from 'product/klarna';
import ExpressCheckoutHelpers from '../checkout/expressCheckout';
import './../checkout/googlePay';
import { appendToUrl } from '../util/common';
import {
    newModalFromString,
    newModalWithOptions,
    ModalShowHide,
    newModalFromSelector
} from '../components/modal';
import ScalaPay from 'product/scalaPay';
import QuickView from 'product/quickView';
import { initColorSlickCarousel } from './../quickAdd';
const summaryHelpers = require('../checkout/summary');
const throttle = require('lodash/throttle');

function formatDate (date) {
    return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
    date.getFullYear();
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
const createErrorNotification = (message) => {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
};

/**
 * re-renders the bonus products pending
 * @param {Object} items - items in the cart
 */
const updateCartBonusProducts = (items) => {
    let bonusProductFound = false;
    let automaticallyAdded = false;
    items.forEach(function (item) {
        if (!bonusProductFound && !automaticallyAdded) {
            if (item.bonusProducts && item.bonusProducts.length > 0) {
                for (let i = 0; i < item.bonusProducts.length; i++) {
                    if (item.bonusProducts[i].freeGiftAutoAdd) {
                        automaticallyAdded = true;
                    }
                }
            }
            if (item.discountLineItems && item.discountLineItems.length > 0 && !automaticallyAdded) {
                for (let i = 0; i < item.discountLineItems.length && !bonusProductFound; i++) {
                    if (item.discountLineItems[i].full) {
                        bonusProductFound = true;
                        $.ajax({
                            url: item.discountLineItems[i].url,
                            method: 'GET',
                            dataType: 'json',
                            success: function (data) {
                                if (data) {
                                    data.isTriggeredByCoupon = true;
                                }
                                ProductHelpers.methods.editBonusProducts(data);
                                $.spinner().stop();
                            },
                            error: function () {
                                $.spinner().stop();
                            }
                        });
                    }
                }
            }
        }
    });
    if (!bonusProductFound || automaticallyAdded) {
        window.location.reload();
    }
};

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
const updateAvailability = (data, uuid) => {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    $('.availability-' + lineItem.UUID).empty();

    if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach(function (message) {
                messages += '<p class="line-item-attributes">' + message + '</p>';
            });
        }

        if (lineItem.availability.inStockDate) {
            messages += '<p class="line-item-attributes line-item-instock-date">' +
                lineItem.availability.inStockDate +
                '</p>';
        }
    }

    $('.availability-' + lineItem.UUID).html(messages);
    if (lineItem.available) {
        $('.uuid-' + lineItem.UUID).removeClass('out-of-stock');
        $('.uuid-' + lineItem.UUID + ' .out-of-stock-label').addClass('hidden');
    }
};

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
const updateProductDetails = (data, uuid) => {
    var lineItem = data.cartModel.items.find(function (item) {
        return item.UUID === uuid;
    });

    if (lineItem.variationAttributes) {
        var colorAttr = lineItem.variationAttributes.find(function (attr) {
            return attr.attributeId === 'color';
        });

        var sizeAttr = lineItem.variationAttributes.find(function (attr) {
            return attr.attributeId === 'size';
        });

        if (sizeAttr) {
            var sizeSelector = '.Size-' + uuid + ' .js-attr-display';
            var newSize = sizeAttr.displayValue;
            $(sizeSelector).text(newSize);
        }

        if (colorAttr) {
            var colorSelector = '.Color-' + uuid + ' .js-attr-display';
            var newColor = lineItem.colorFamily + ' - ' + colorAttr.displayValue + ' - ' + colorAttr.attrId;
            $(colorSelector).text(newColor);
        }

        var imageSelector = '.product-info.uuid-' + uuid + ' img.product-image';
        $(imageSelector).attr('src', lineItem.images.small[0].url);
        $(imageSelector).attr('alt', lineItem.images.small[0].alt);
        $(imageSelector).attr('title', lineItem.images.small[0].title);
    }

    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', data.newProductId);

    $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);

    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
    $(priceSelector).text(lineItem.price.sales.formatted);
    $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

    if (lineItem.price.list) {
        var listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
    }

    if (lineItem.wrappedQuantity == 0) {
        $('.js-wrapping-info-container-' + lineItem.uuid).hide();
    } else {
        $('.js-wrapping-info-container-' + lineItem.uuid).show();
        $('.js-wrapped-quantity-' + lineItem.uuid).html(lineItem.wrappedQuantity);
    }
};

/**
 * Updates details of a gift card product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
const updateGiftCardDetails = (data, uuid) => {
    var lineItem = data.cartModel.items.find(function (item) {
        return item.UUID === uuid;
    });

    var imageSelector = '.product-info.uuid-' + uuid + ' img.product-image';
    $(imageSelector).attr('src', data.item.imgUrl);

    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', data.newProductId);

    $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);

    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
    $(priceSelector).text(lineItem.priceTotal.price);
    $(priceSelector).attr('content', lineItem.priceTotal.price);

    var listPriceSelector = '.product-info.uuid-' + uuid + ' .line-item-total-price-amount span';
    $(listPriceSelector).text(lineItem.priceTotal.price);
    $(listPriceSelector).attr('content', lineItem.priceTotal.price);
};

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
const confirmDelete = (actionUrl, productID, productName, uuid) => {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
};

const confirmRemoveProduct = (params, modal) => {
    $.spinner().start();

    const url = appendToUrl(params.actionUrl, {
        pid: params.productID,
        uuid: params.uuid,
        uniqueIdentifier: params.uniqueIdentifier
    });

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (data.klarnaExpressEnabled !== undefined) {
                let klarnaIsShowing = $('.js-klarna-container').length > 0;
                if (!!data.klarnaExpressEnabled !== klarnaIsShowing) {
                    location.reload();
                    return;
                }
            }
            let outDiv = $('.uuid-' + params.uuid + ' .analytics');
            $('body').trigger('removeItemFromCartSuccessful', { ...data, params, outerDiv: outDiv });
            if (params.deleteMessage) {
                $('.uuid-' + params.uuid).first().replaceWith(params.deleteMessage);
            }
            if ($('.bonus-product-line-item').length > 0 || $('.out-of-stock').length > 0) {
                location.reload();
            } else if (data.basket.items.length === 0) {
                $('body').trigger('removedAllItemsFromCart');
                if (!modal.isWishlistMove) {
                    $('.cart').empty().append(`
                    <div class="grid-x">
                        <div class="cell">
                            <h1>${data.basket.resources.emptyCartMsg}</h1>
                        </div>
                    </div>`);
                }
                $('.number-of-items').empty().append(data.basket.resources.numberOfItems);

                if (data.basket.numItems > 0) {
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                } else {
                    location.reload();
                }
            } else {
                if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                    for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                        $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                    }
                }
                $('.uuid-' + params.uuid).remove();
                if (!data.basket.hasBonusProduct) {
                    $('.bonus-product').remove();
                }
                $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                $('.promos').empty().append(data.basket.totals.promocodesHtml);
                cart.updateCartTotals(data.basket, params.skipConfirm);
                cart.updateApproachingDiscounts(data.basket.approachingDiscounts);
                cart.updateReachedDiscounts(data.basket.appliedShippingDiscounts);

                if (data.basket.items.length === 1 && data.basket.items[0].isGiftCard) {
                    location.reload();
                }
                if ($('div[data-is-smart-gift-item="true"]').length > 0) {
                    location.reload();
                }
                if (!data.hasApproachingDiscount || params.skipConfirm) {
                    location.reload();
                }

                if (data.basket.shipments && data.basket.shipments.length) {
                    if (data.basket.shipments[0].shippingMethodRecapTitle) {
                        $('.shipping-method-label').empty().append(data.basket.shipments[0].shippingMethodRecapTitle);
                    }
                    data.basket.shipments[0].shippingMethods.forEach(function (shippingMethod) {
                        if (shippingMethod.isElectronicShipping) {
                            let lastAction = localStorage.getItem('standardProductRemoved');
                            if (lastAction) {
                                localStorage.setItem('standardProductRemoved', '');
                                location.reload();
                            }
                        } else {
                            localStorage.setItem('standardProductRemoved', 'yes');
                        }
                    });
                }
                $('body').trigger('setShippingMethodSelection', data.basket);
                cart.validateBasket(data.basket);
            }
            modal.close();
            $.spinner().stop();
            $('.card.error-message').remove();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
            }
            $.spinner().stop();
        }
    });
};

/**
 * replace content of modal
 * @param {Object} params - modal parameters
 * @param {boolean} isPromoCode - promo code flow otherwise is loyalty coupon flow
 */
const confirmRemovePromoCode = (params, isPromoCode = true) => {
    $.spinner().start();

    const url = appendToUrl(params.actionUrl, {
        code: params.couponCode,
        uuid: params.uuid
    });

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            $('.coupon-code-field').val('');
            $('.coupon-code-field').prop('disabled', false);
            $('.coupon-code-field').removeClass('coupon-code-field--applied');
            $('.coupon-uuid-' + params.uuid).remove();
            $('.remove-coupon').addClass('hidden');
            $('.coupon-success-icon-wrapper').addClass('hidden');
            $('.js-promocode-add-btn').removeClass('hidden');
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
            $('body').trigger('cart:afterCouponApply', { code: params.couponCode, uuid: params.uuid, btnAction: 'remove', isLoyalty: !isPromoCode });
            cart.updateCartTotals(data, true);
            cart.updateApproachingDiscounts(data.approachingDiscounts);
            cart.updateReachedDiscounts(data.appliedShippingDiscounts);
            cart.validateBasket(data);
            summaryHelpers.updateTotals(data.totals);
            cart.updateShippingTracker(data.freeShippingTracker);
            if (isPromoCode) {
                $('.js-promo-code').removeClass('applied');
                $('.loyalty-coupons-container').removeClass('disabled');
            } else {
                $('.js-promo-code').removeClass('disabled');
                $('.js-select-loyalty-coupon').prop('checked', false).attr('checked', false);
                $('.js-loyalty-coupon-applied').addClass('hide');
                $('.loyalty-wrapper').removeClass('hidden');
            }
            $('.js-applied-coupon-message').addClass('hide');
            if ($('meta[http-equiv=content-language]').attr('content') === 'ru-RU') {
                window.location.reload();
            }
            $.spinner().stop();
            window.location.reload();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
                $.spinner().stop();
            }
        }
    });
};

/**
 * Move close button inside modal content box
 */
const moveModalCloseButton = () => {
    //
    var close = document.querySelector('.tingle-modal__close');
    var modalContent = document.querySelector('.tingle-modal-box__content');
    modalContent.appendChild(close);
};

const getProductVariationGroup = (productId, color) => {
    let pid = productId.split(' ')[0].trim();
    color = color + '';
    let selectedVariation = color.trim();

    return pid + '_color_' + selectedVariation;
};

const enableExpressButton = (data, isFirstCourierApple) => {
    var expressMethodEnabled = true;
    if (data.items) {
        const orderItems = data.items;
        for (let item of orderItems) {
            if (item.wrappedQuantity || item.wrappedQuantity > 0 || item.isGiftKit) {
                expressMethodEnabled = false;
            }
        }
    }
    if (expressMethodEnabled) {
        $('.js-paypal-container').removeClass('disabled');
        $('.js-amazon-pay-container').removeClass('disabled');
        $('.js-google-pay-container').removeClass('disabled');
        // if the shipping method selected is not the default courier, applePay button should be disabled
        if (isFirstCourierApple) {
            $('.js-apple-pay-container').removeClass('disabled');
        } else {
            $('.js-apple-pay-container').addClass('disabled');
        }
    } else {
        $('.js-paypal-container').addClass('disabled');
        $('.js-apple-pay-container').addClass('disabled');
        $('.js-amazon-pay-container').addClass('disabled');
        $('.js-google-pay-container').addClass('disabled');
    }
};

const initQuickviewImageCarousel = modal => {
    const $carousel = $(modal.modalBox)
        .find('.image-cell.carousel-inner')
        .not('.slick-initialized');

    if ($carousel.children('.carousel-item').length <= 1) {
        return;
    }

    $carousel.slick({
        dots: false,
        arrows: false,
        slidesToShow: 3.4,
        slidesToScroll: 3,
        draggable: true,
        infinite: false,
        swipeToSlide: true,
        waitForAnimate: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2.85,
                    slidesToScroll: 2
                }
            }
        ]
    });
};

export class Cart {
    constructor () {
        this.removeModalID = 'removeProductModal';
        this.editModalID = 'editProductModal';
        this.removeCouponModalID = 'removeCouponModal';
        this.currentlyOpenedModal = null;
        this.coupon = new Coupon('.checkbox-promo-block');
        this.btnOpenSelector = '.js-open-coupon';
        this.couponModal = '#couponModal';
        this.btnLoyaltyCoupon = '.js-select-loyalty-coupon';
    }

    run () {
        // ProductHelpers is already initialized in productDetail, which is imported in cart.isml
        // ProductHelpers.run();
        this.persistentLoginListener();
        ScalaPay.run();
        Klarna.loadWidget();
        this.removeProduct();
        this.afterRemoveFromCart();
        this.editProduct();
        this.editBonusProducts();
        this.updateAddToCart();
        this.updateAvailability();
        this.afterAttributeSelect();
        this.updateCartProductGlobal();
        this.moveToWishlist();
        this.checkWishlistItems();
        this.applicablePromotion();
        this.openTooltip();
        this.openTooltipMobile();
        this.checkForDifferentSizesSameProduct();
        this.adjustEswFabPosition();

        paypalUtilsInit();
        paypalMFRAInit();
        ExpressCheckoutHelpers.run();
        this.shippingRecap();
        this.mobileOpenCheckoutCTA();
        this.initCoupon();
        this.removeAllProducts();

        $('body').on('click', '#apple-pay-btn', function () {
            $('body').trigger('analytics:applepay');
            localStorage.setItem('selectedPaymentMethod', 'DW_APPLE_PAY');
        });
        if (!window.ApplePaySession || !window.ApplePaySession.canMakePayments() || $('#apple-pay-btn').length < 1) {
            $('.js-apple-pay-container').remove();
        }
        QuickView.run();
    }

    checkForDifferentSizesSameProduct ()  {
        var sizebayCartCheckerEvent = false;
        var idSizeMap = new Map();
        for (let elem of document.querySelector('.cart-page').querySelectorAll('.checkout-product')){
            let id = elem.getAttribute('data-item_id');
            let size = elem.getAttribute('data-size');
            if (id && size) {
                if(idSizeMap.has(id)) {
                    if (idSizeMap.get(id) !== size) {
                        sizebayCartCheckerEvent = true;
                    }
                } else {
                    idSizeMap.set(id, size);
                }
            }
        }
        if (!!sizebayCartCheckerEvent) {
            var sizebayCartChecker = new CustomEvent('sizebay:loaded');
            document.dispatchEvent(sizebayCartChecker);
        }
    }

    adjustEswFabPosition () {
        const $proceedContainer = $('.fake-proceed-container');
        if (!$proceedContainer.length) {
            return;
        }

        const GAP = 16;
        const updateFabOffset = () => {
            const containerHeight = $proceedContainer.is(':visible') ? $proceedContainer.outerHeight() : 0;
            if (containerHeight > 0) {
                document.documentElement.style.setProperty('--esw-fab-cart-offset', (containerHeight + GAP) + 'px');
                $('body').addClass('has-cart-fab-offset');
            } else {
                $('body').removeClass('has-cart-fab-offset');
            }
        };

        updateFabOffset();

        if (window.ResizeObserver) {
            new window.ResizeObserver(updateFabOffset).observe($proceedContainer.get(0));
        } else {
            // Fallback for browsers without ResizeObserver support only.
            $(window).on('resize.eswFabOffset', throttle(updateFabOffset, 200));
        }
    }

    initCoupon () {
        this.promoCode();
        this.removeLoyaltyCouponFromCart();
        this.removePromoCode();
        this.coupon.run();
        this.loyaltyCouponModal();
    }

    persistentLoginListener () {
        if ($('#login-popup .js-title-login-persistent').length) {
            $('.cartCustomerNotAuthenticated').trigger('click');
            $('body').on('cart:invalidatePersistentCustomerSession', function (e, data) {
                var url = $('.cartCustomerNotAuthenticated').data('url');
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    success: data => {
                        location.reload();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
        }
    }

    loyaltyCouponModal () {
        const modal = new ModalShowHide('#couponModal');

        $(document).on('click', '.js-open-coupon, .js-edit-coupon', (e) => {
            modal.show();
            if (!$('.js-loyalty-coupon-applied').hasClass('hide')) {
                $('.js-select-loyalty-coupon').prop('checked', false).attr('checked', false);
                var uuid = $('.js-remove-loyalty-coupon').data('uuid');
                $('.js-select-loyalty-coupon[data-uuid="' + uuid + '"]').prop('checked', true).attr('checked', true);
            }

            $('.js-coupon-error-minimumOrder').addClass('hide');

            const isCouponChecked = $('.js-select-loyalty-coupon:checked').length > 0;
            if (!isCouponChecked) {
                $('#couponModal .container-error-message-allProductsDiscounted').addClass('hide');
            } else {
                $('#couponModal .container-error-message-allProductsDiscounted').removeClass('hide');
            }

            $('#couponModal').on('click', '.js-close-button-coupon', (e) => {
                modal.hide();
            });
        });

        this.loyaltyCouponConfirmSelection(modal);
        this.loyaltyCouponManageSelection();
    }

    loyaltyCouponConfirmSelection (modal) {
        $('#couponModal').on('click', '.js-apply-coupon', (e) => {
            const reqUrl = document.getElementById('addRemoveURL').value;
            const $selectedCoupons = $('.js-select-loyalty-coupon:checked');

            let arrayOfCoupons = [];
            for (let i = 0; i < $selectedCoupons.length; i++) {
                let $coupon = $selectedCoupons.eq(i);
                arrayOfCoupons.push({
                    couponCode: $coupon.data('fidelityeventid'),
                    id: $coupon.data('id'),
                    coupon: $coupon.data('coupon'),
                    pin: $coupon.data('pin'),
                    fidelityEventId: $coupon.data('fidelityeventid')
                });
            }

            const $allCoupons = $('.js-select-loyalty-coupon');
            let arrayOfCouponsToRemove = [];
            for (let i = 0; i < $allCoupons.length; i++) {
                let $coupon = $allCoupons.eq(i);
                if (!$coupon.is(':checked') && $coupon.data('uuid')) {
                    arrayOfCouponsToRemove.push($coupon.data('uuid'));
                }
            }

            // Move the FE to the correct state
            $('.js-coupon-error').addClass('hide');
            $('.js-loyalty-coupon-applied').addClass('hide');
            $('.js-promo-code').removeClass('disabled');
            $('.js-apply-coupon').attr('disabled', true);

            $.spinner().start();
            $.ajax({
                url: reqUrl,
                data: {
                    coupons: JSON.stringify(arrayOfCoupons),
                    couponsToRemove: JSON.stringify(arrayOfCouponsToRemove)
                },
                method: 'POST',
                dataType: 'json',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('.js-coupon-error').removeClass('hide');
                        return;
                    }

                    for (let i = 0; i < $allCoupons.length; i++) {
                        const $couponContainer = $allCoupons.eq(i);
                        const couponCode = $couponContainer.data('fidelityeventid');

                        for (let j = 0; j < data.reedemedCoupons.length; j++) {
                            if (data.reedemedCoupons[j].fidelityEventId === couponCode) {
                                let couponUUID = data.reedemedCoupons[j].uuid;

                                // Fill up UUID to manage coupon removal inside modal
                                $couponContainer.data('uuid', couponUUID).attr('data-uuid', couponUUID);

                                // Fill up data to manage coupon removal outside modal
                                $('.js-coupon-name').html($couponContainer.data('couponName'));
                                $('.js-remove-loyalty-coupon').data('code', data.reedemedCoupons[j].couponCode);
                                $('.js-remove-loyalty-coupon').data('uuid', couponUUID);

                                // Show loyalty coupon area
                                $('.js-loyalty-coupon-applied').removeClass('hide');
                                $('.loyalty-wrapper').addClass('hidden');

                                $('.js-coupon-end-date').text($('.js-coupon-end-date').data('validUntil') + ' ' + $couponContainer.data('endDate'));
                                $('.js-coupon-description').html($couponContainer.data('description'));

                                // Block promo code area
                                if ($('.js-coupon-area').hasClass('active')) {
                                    $('.js-coupon-area').trigger('click');
                                }
                                $('.js-promo-code').addClass('disabled');

                                // Show checkout message of applied coupons
                                if (data.cart.coupon) {
                                    $('.js-applied-coupon-amount').text(data.cart.coupon.message.loyaltyCouponAmount);
                                    $('.js-applied-coupon-total').text(data.cart.coupon.message.totalOrder);
                                    $('.js-applied-coupon-message').removeClass('hide');
                                }
                                break;
                            }
                        }
                    }

                    let errorMinimumOrder = false;
                    if (!data.hasApproachingDiscount) {
                        errorMinimumOrder = true;
                        const couponValueMsg = data.couponValueMsg;
                        const $couponMinError = $('.js-coupon-error-minimumOrder');
                        if ($couponMinError.find('.js-coupon-error-message-text').length) {
                            $couponMinError.find('.js-coupon-error-message-text').html(couponValueMsg);
                        } else {
                            $couponMinError.html(couponValueMsg);
                        }
                        $('.js-coupon-error-minimumOrder').removeClass('hide');
                        $('.js-apply-coupon').prop('disabled', true);
                    }

                    let errorFound = false;
                    for (let i = 0; i < data.notRedimable.length; i++) {
                        errorFound = true;
                        const couponCode = data.notRedimable[i];
                        const $couponContainer = $(`.js-select-loyalty-coupon[data-fidelityeventid="${couponCode}"]`);
                        $couponContainer.prop('checked', false);

                        if (data.couponValueMsg) {
                            const $couponMinError = $('.js-coupon-error-minimumOrder');
                            if ($couponMinError.find('.js-coupon-error-message-text').length) {
                                $couponMinError.find('.js-coupon-error-message-text').html(data.couponValueMsg);
                            } else {
                                $couponMinError.html(data.couponValueMsg);
                            }
                            $('.js-coupon-error-minimumOrder').removeClass('hide');
                            $('.js-apply-coupon').prop('disabled', true);
                        } else {
                            $('.js-coupon-error').removeClass('hide');
                        }
                    }

                    // Update the FE with the new totals
                    cart.updateCartTotals(data.cart);
                    cart.updateApproachingDiscounts(data.cart.approachingDiscounts);
                    cart.updateReachedDiscounts(data.cart.appliedShippingDiscounts);
                    cart.validateBasket(data.cart);
                    summaryHelpers.updateTotals(data.cart.totals);

                    if (data.reedemedCoupons && data.reedemedCoupons.length > 0) {
                        $('.js-loyalty-coupon-empty-box').addClass('hide');
                        $('.js-loyalty-coupon-applied').removeClass('hide');
                        $('.js-coupon-title').addClass('hide');
                        $('.js-coupon-title-add').removeClass('hide');
                    } else {
                        $('.js-loyalty-coupon-empty-box').removeClass('hide');
                        $('.js-loyalty-coupon-applied').addClass('hide');
                        $('.js-coupon-title').removeClass('hide');
                        $('.js-coupon-title-add').addClass('hide');
                        $('.js-applied-coupon-message').addClass('hide');
                    }

                    if (!errorFound && !errorMinimumOrder) {
                        if (arrayOfCoupons.length > 0 && data.reedemedCoupons && data.reedemedCoupons.length > 0) {
                            $('body').trigger('loyaltyCoupon:apply', { 'couponCode': arrayOfCoupons[0].coupon });
                        }
                        modal.hide();
                        if (arrayOfCouponsToRemove.length === 0 && data.isBonusProductSelectionPending && data.cart && data.cart.items) {
                            updateCartBonusProducts(data.cart.items);
                        }
                    }
                },
                error: function (data) {
                    $('.js-coupon-error').removeClass('hide');
                    $.spinner().stop();
                }
            });
        });
    }

    loyaltyCouponManageSelection () {
        $('#couponModal').on('change', this.btnLoyaltyCoupon, evt => {
            $('.coupon-item-box').removeClass('change-border-coupon');
            $('.js-coupon-error-minimumOrder').addClass('hide');
            if ($(evt.currentTarget).is(':checked')) {
                addLoyaltyCoupon(evt);
            } else {
                removeLoyaltyCoupon(evt);
            }
        });

        $('#couponModal').on('click', '.coupon-item-box', function (e) {
            if ($(e.target).closest('.wrapper-select').length) {
                return;
            }

            const $checkbox = $(this).find('.js-select-loyalty-coupon');
            if ($checkbox.length) {
                $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
            }
        });

        const removeLoyaltyCoupon = () => {
            let removedCouponCount = $('.js-select-loyalty-coupon:not([data-uuid=""]):not(:checked)').length;
            const $allDiscountedMessage = $('#couponModal .container-error-message-allProductsDiscounted');
            const isCouponChecked = $('.js-select-loyalty-coupon:checked').length > 0;

            if (!isCouponChecked) {
                if ($allDiscountedMessage.length > 0) {
                    $allDiscountedMessage.addClass('hide');
                }
                if (removedCouponCount === 0) {
                    $('.js-apply-coupon').prop('disabled', true);
                }
            }

            if (removedCouponCount > 0) {
                if ($allDiscountedMessage.length > 0) {
                    if (isCouponChecked) {
                        $allDiscountedMessage.removeClass('hide');
                    }
                    $('.js-apply-coupon').prop('disabled', true);
                } else {
                    $('.js-apply-coupon').prop('disabled', false);
                }
            }
        };

        // De-select other coupons and enables CTA
        const addLoyaltyCoupon = (evt) => {
            const $currentSelection = $(evt.currentTarget);
            $('.js-select-loyalty-coupon:checked').not($currentSelection).prop('checked', false);
            
            const $allDiscountedMessage = $('#couponModal .container-error-message-allProductsDiscounted');
            if ($allDiscountedMessage.length > 0) {
                $allDiscountedMessage.removeClass('hide');
                $('.js-apply-coupon').prop('disabled', true);
            } else {
                $('.js-apply-coupon').prop('disabled', false);
            }
            $(evt.currentTarget).closest('.box-loyalty-coupon').find('.coupon-item-box').addClass('change-border-coupon');
        };
    }

    moveToWishlist () {
        $('.js-move-to-wishlist').on('click', e => {
            require('../product/wishlistHeart').moveToWishlistHelper(e).then(function (rsp) {
                if (rsp.error === true) {
                    $.spinner().stop();
                } else {
                    const pid = $(e.currentTarget).data('pid');
                    const actionUrl = $(e.currentTarget).closest('.product-info').find(`.remove-product[data-pid="${pid}"]`).data('action');
                    const availability = $(e.currentTarget).closest('.product-info').find(`.analytics.checkout[data-item_sfcc="${pid}"]`).data('item_availability');
                    const uuid = $(e.currentTarget).closest('.product-info').find(`.remove-product[data-pid="${pid}"]`).data('uuid');

                    $('body').trigger('wishlist:add', { sku: pid, sender: 'cart', availability: availability });

                    const data = {
                        actionUrl: actionUrl,
                        productID: pid,
                        uuid: uuid,
                        deleteMessage: $('.moved-to-wishlist-message-wrapper').html()
                    };
                    confirmRemoveProduct(data, {close: function () {}, isWishlistMove: true});
                }
            });
        });
    }

    removeProduct () {
        $('body').on('click', '.remove-product', e => {
            e.preventDefault();
            if ($(e.currentTarget).data('skip-confirm') === true) {
                // product info
                const data = {
                    actionUrl: $(e.currentTarget).data('action'),
                    productID: $(e.currentTarget).data('pid'),
                    uuid: $(e.currentTarget).data('uuid'),
                    deleteMessage: $('.product-removed-message-wrapper').html(),
                    skipConfirm: true
                };

                confirmRemoveProduct(data, {close: function () {}});
            } else {
                // product info
                const data = {
                    actionUrl: $(e.currentTarget).data('action'),
                    productID: $(e.currentTarget).data('pid'),
                    uuid: $(e.currentTarget).data('uuid'),
                    available: $(e.currentTarget).data('available')
                };

                // create and open confirmation modal
                const htmlContent = document.getElementById('removeProductModal').innerHTML;
                const modal = newModalFromString(htmlContent, false, ['cart-remove-product']);

                // prepare modal
                const productName = e.currentTarget.dataset.name;
                $(modal.modalBox).find('.product-to-remove').text(productName);

                $(modal.modalBox).find('.js-move-to-wishlist').data('pid', data.productID);
                $(modal.modalBox).on('click', '.js-move-to-wishlist', e => {
                    require('../product/wishlistHeart').moveToWishlistHelper(e).then(function (rsp) {
                        if (rsp.error === true) {
                            $.spinner().stop();
                        } else {
                            const pid = $(e.currentTarget).data('pid');
                            const actionUrl = $(`.remove-product[data-pid="${pid}"]`).data('action');
                            const availability = $(e.currentTarget).closest('.product-info').find(`.analytics.checkout[data-pid="${pid}"]`).data('item_availability');
                            const uuid = $(`.remove-product[data-pid="${pid}"]`).data('uuid');

                            $('body').trigger('wishlist:add', { sku: pid, sender: 'cart', availability: availability });

                            const data = {
                                actionUrl: actionUrl,
                                productID: pid,
                                uuid: uuid
                            };
                            confirmRemoveProduct(data, modal);
                        }
                    });
                });

                $(modal.modalBox).on('click', '.cart-delete-confirmation-btn', () => {
                    confirmRemoveProduct(data, modal);
                });

                moveModalCloseButton();
                modal.open();

                $(modal.modalBox).on('click', '.close', function () {
                    modal.close();
                    modal.destroy();
                });
                this.currentlyOpenedModal = modal;
            }
        });
    }

    removeAllProducts () {
        $('body').on('click', '.js-remove-all-products', e => {
            const htmlContent = document.getElementById('removeAllProductsModal').innerHTML;
            const modal = newModalFromString(htmlContent, false, ['cart-remove-all-products']);
            $(modal.modalBox).on('click', '.tingle-modal__close', function () {
                modal.close();
                modal.destroy();
            });
            modal.open();
            $(modal.modalBox).on('click', '.remove-all-products', function (e) {
                $.spinner().start();

                $.ajax({
                    url: $(e.target).data('action'),
                    type: 'get',
                    success: function () {
                        $('body').trigger('removedAllItemsFromCart');
                        $.spinner().stop();
                        modal.close();
                        location.reload();
                    },
                    error: function (data) {
                        $.spinner().stop();
                        $(modal.modalBoxContent).find('.modal-body')
                            .hide()
                            .html('<p>' + data.responseJSON.message + '</p>')
                            .fadeIn();
                    }
                });
            });

            this.currentlyOpenedModal = modal;
        });
    }

    afterRemoveFromCart () {
        $('body').on('afterRemoveFromCart', function (e, data) {
            e.preventDefault();
            confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
        });
    }

    editProduct () {
        $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', e => {
            e.preventDefault();

            $.spinner().start();
            // modal options
            var modalOptions = {
                footer: false,
                closeMethods: ['overlay', 'button', 'escape'],
                closeLabel: '<svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"> <path d="M12,11.3L22.3,1L23,1.7L12.7,12L23,22.3L22.3,23L12,12.7L1.7,23L1,22.3L11.3,12L1,1.7L1.7,1C1.7,1,12,11.3,12,11.3z"/></svg>',
                cssClass: ['quickview-modal', 'js-cart-edit-product-modal'],
                onClose: () => {
                    $(modal.modalBox).find('.image-cell.carousel-inner.slick-initialized').slick('unslick');
                    modal.destroy();
                }
            };
            const modal = newModalWithOptions(modalOptions);
            this.currentlyOpenedModal = modal;

            $.ajax({
                url: $(e.currentTarget).attr('href'),
                method: 'GET',
                dataType: 'json',
                success: rsp => {
                    // const modal = newModalFromString(html);
                    modal.setContent(rsp.renderedTemplate);
                    // Move close button inside modal content box
                    moveModalCloseButton();
                    $('.tingle-modal').addClass('quickview-modal--tezenis');
                    $(modal.modalBox).addClass('rightModalAttribute');
                    modal.open();
                    initQuickviewImageCarousel(modal);
                    if ($('.quickview-modal--tezenis .quantity-value').first().text().trim() === '1') { $('[data-action="decrease"]').addClass('disabled'); }
                    // Slick carousel
                    initColorSlickCarousel();
                    if ($(modal.modalBox).closest('.js-cart-edit-product-modal').length) {
                        const clonedQuantityContainer = $('.js-quantity-container').clone(true);
                        $('.js-quantity-container').remove();
                        clonedQuantityContainer.appendTo('.sizes-container');
                    }
                    $('.quickviewCarousel__slider').slick({
                        arrows: true,
                        prevArrow: $('.prev-button'),
                        nextArrow: $('.next-button'),
                        dots: false,
                        infinite: true,
                        draggable: false,
                        speed: 500,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 480,
                                settings: {
                                    dots: true
                                }
                            }
                        ]
                    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        $('.quickviewCarousel__thumbnail').removeClass('active');
                        $('.quickviewCarousel__thumbnail').eq(nextSlide).addClass('active');
                    });
                    $('.quickviewCarousel__thumbnail').click(function () {
                        $('.quickviewCarousel__slider').slick('slickGoTo', $(this).index());
                    });
                    $.spinner().stop();

                    $(modal.modalBox).on('click', '.close-custom', function () {
                        modal.close();
                        modal.destroy();
                    });
                    init();
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
    }

    promoCode () {
        $('.js-promo-block .js-promo-header').on('click', function (e) {
            $(e.currentTarget).toggleClass('active');
            $('.js-code-input').stop().slideToggle();
        });

        $('.promo-code-form').submit(function (e) {
            e.preventDefault();
            $.spinner().start();

            // Reset state
            var $form = $('.promo-code-form');
            $('.coupon-code-field').removeClass('is-invalid');
            $('.coupon-error-message').empty();
            $('.coupon-missing-error').addClass('hidden');
            $('.promocode.error-message').addClass('hidden');

            // if the user did not insert any promocode
            if (!$('.coupon-code-field').val()) {
                $('.coupon-code-field').addClass('is-invalid');
                $('.promocode.error-message').removeClass('hidden');
                $('.coupon-missing-error').removeClass('hidden');
                $.spinner().stop();
                return false;
            }

            $.ajax({
                url: $form.attr('action'),
                type: 'GET',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (data.klarnaExpressEnabled !== undefined) {
                        let klarnaIsShowing = $('.js-klarna-container').length > 0;
                        if (!!data.klarnaExpressEnabled !== klarnaIsShowing) {
                            location.reload();
                            return;
                        }
                    }
                    if (data.error) {
                        $('body').trigger('cart:afterCouponApply', { code: '', uuid: '', btnAction: 'apply' });
                        $('.promocode.error-message').show();
                        $('.coupon-code-field').addClass('is-invalid');
                        $('.coupon-error-message').empty().append(data.errorMessage);
                        $('.coupon-success-icon-wrapper').addClass('hidden');
                    } else {
                        // if the promocode has been successfully added, we have
                        // to disable the input field and change the button
                        // to Remove
                        $('.coupon-code-field').prop('disabled', true);
                        $('.coupon-code-field').addClass('coupon-code-field--applied');

                        $('.remove-coupon').removeClass('hidden');
                        $('.coupon-success-icon-wrapper').removeClass('hidden');

                        // TODO controllare se i dati siano corretti
                        let uuid, couponcode;
                        for (let i = 0; i < data.totals.discounts.length; i++) {
                            let currentDiscount = data.totals.discounts[i];
                            if (currentDiscount.type === 'coupon') {
                                uuid = currentDiscount.UUID;
                                couponcode = currentDiscount.couponCode;
                                break;
                            }
                        }
                        $('body').trigger('cart:afterCouponApply', { code: couponcode, uuid: uuid, btnAction: 'apply' });
                        $('.remove-coupon').data('uuid', uuid);
                        $('.remove-coupon').data('code', couponcode);
                        $('.js-promocode-add-btn').addClass('hidden');
                        $('.coupons-and-promos').empty().append(data.totals.discountsHtml);

                        // Show checkout message of applied coupons
                        if (data.coupon) {
                            $('.js-applied-coupon-amount').text(data.coupon.message.promoCodeAmount);
                            $('.js-applied-coupon-total').text(data.coupon.message.totalOrder);
                            $('.js-applied-coupon-message').removeClass('hide');
                        }

                        // Update the FE with the new totals
                        const basket = data.cart;

                        if (!basket || !basket.items) {
                            $.spinner().stop();
                            return;
                        }
                        
                        if (data.renderedBagContainer) {
                            $('.js-cart-bag-wrapper').data('just-replaced', true);
                            $('.js-cart-bag-wrapper').empty().append(data.renderedBagContainer);
                        }
                        
                        cart.updateCartTotals(basket);
                        cart.updateApproachingDiscounts(basket.approachingDiscounts);
                        cart.updateReachedDiscounts(basket.appliedShippingDiscounts);
                        cart.validateBasket(basket);
                        summaryHelpers.updateTotals(basket.totals);
                        cart.updateShippingTracker(basket.freeShippingTracker);
                        if ($('meta[http-equiv=content-language]').attr('content') === 'ru-RU') {
                            window.location.reload();
                        }

                        // Update FE styling
                        $('.js-promo-code').addClass('applied');
                        $('.loyalty-coupons-container').addClass('disabled');

                        if (data.isBonusProductSelectionPending && data.cart && data.cart.items) {
                            updateCartBonusProducts(data.cart.items);
                        }
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    $('body').trigger('cart:afterCouponApply', { code: '', uuid: '', btnAction: 'apply' });
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
            return false;
        });
    }

    removeLoyaltyCouponFromCart () {
        $('body').on('click', '.js-remove-loyalty-coupon', function (e) {
            e.preventDefault();
            const data = {
                actionUrl: $(e.currentTarget).data('action'),
                couponCode: $(e.currentTarget).data('code'),
                uuid: $(e.currentTarget).data('uuid')
            };
            confirmRemovePromoCode(data, false);
        });
    }

    removePromoCode () {
        $('body').on('click', '.remove-coupon', function (e) {
            e.preventDefault();
            const $el = $(e.currentTarget);

            const actionUrl = $('#removeCouponModal').attr('data-action');

            if (!actionUrl) {
                return;
            }

            const data = {
                actionUrl: actionUrl,
                couponCode: $el.data('code'),
                uuid: $el.data('uuid')
            };

            confirmRemovePromoCode(data);
        });
    }

    editBonusProducts () {
        $('body').on('click', '.cart-page .bonus-product-button', function () {
            $.spinner().start();
            $.ajax({
                url: $(this).data('url'),
                method: 'GET',
                dataType: 'json',
                success: function (data) {
                    if (data.noedit) {
                        location.reload();
                        return;
                    }
                    ProductHelpers.methods.editBonusProducts(data);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }

    updateAddToCart () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.update-cart-product-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order') ||
                !$('.global-availability', dialog).data('available')
            );

            $('button.update-cart-product-global').not('.add-mobile-soldout-add').prop('disabled', ((!response.product.available) || response.product.comingSoon));
            $('button.update-cart-product-global').data('disabled', !response.product.readyToOrder);
        });
    }

    updateAvailability () {
        $('body').on('product:updateAvailability', function (e, response) {
            // If in PDP return as detail.js provides same code
            if ($('.product-detail').length > 0) {
                return;
            }

            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .removeClass('text-brand-blue')
                .removeClass('text-brand-green')
                .removeClass('text-salmon')
                .addClass('text-medium-gray')
                .empty()
                .html(response.message);

            if (response.product.available) {
                $('.product-availability', response.$productContainer)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .addClass('text-brand-green')
                    .removeClass('text-medium-gray');

                if (response.product.availability.lowStockItems) {
                    $('.product-availability', response.$productContainer)
                        .find('.availability-msg')
                        .removeClass('text-brand-green')
                        .removeClass('text-medium-gray')
                        .addClass('text-salmon');
                }
            } else if (response.product.comingSoon) {
                $('.product-availability', response.$productContainer)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .addClass('text-brand-blue')
                    .removeClass('text-medium-gray');
            }

            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
                if (response.product.available) {
                    $('.global-availability', dialog)
                        .data('ready-to-order', response.product.readyToOrder)
                        .data('available', response.product.available)
                        .find('.availability-msg')
                        .addClass('text-brand-green')
                        .removeClass('text-medium-gray');
                }
            }
        });
    }

    afterAttributeSelect () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview .bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
            }
            if (response.type === 'color') {
                if ($(response.container).hasClass('product-freegift')) {
                    response.data.product.isFreeGist = true;
                }
                $('body').trigger('product:didChangeColorForProductDetails', response.data.product);
            }
        });
    }

    updateCartProductGlobal () {
        $('body').on('click', '.update-cart-product-global', e => {
            e.preventDefault();

            var updateProductUrl = $(e.currentTarget).closest('.cart-and-ipay').find('.update-cart-url').val();
            var selectedQuantity = $(e.currentTarget).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
            var uuid = $(e.currentTarget).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

            var form = {
                uuid: uuid,
                pid: ProductHelpers.methods.getPidValue($(e.currentTarget)),
                quantity: selectedQuantity
            };

            const isGiftCardProduct = $(e.currentTarget).data('giftcard');
            if (isGiftCardProduct) {
                // Validate price
                let amountSelectorOk = true;
                if ($('.js-amount-selector.active').length === 0 || $('.js-amount-selector.active').data('amount') === 0) {
                    $('.js-price-validation-error-not-selected').removeClass('hidden');
                    amountSelectorOk = false;
                }

                let errors = [];
                let container = $('.parsleyValidatableElement');
                for (let i = 0; i < container.length; i++) {
                    let validator = container.eq(i).parsley();
                    validator.validate();
                    if (!validator.isValid()) {
                        errors.push(validator);
                    }
                }

                if (errors.length > 0 || !amountSelectorOk) {
                    return;
                }

                let pid = ProductHelpers.methods.getPidValue($(e.currentTarget));
                uuid = $(e.currentTarget).data('uid');

                let country = $('#countrySelector').val();
                let destinationName = $('.js-giftcardNameTo').val();
                let destinationMail = $('#giftcard--mail-to').val();
                let senderName = $('.js-giftcardYourName').val();
                let message = $('#contact-form-message').val();
                let amount = $('.js-amount-selector.active').attr('data-amount');

                let dateString = $('.datepickerTriggerElement').data('date');
                if (dateString.match(/-/g).length !== 2) {
                    dateString = formatDate(new Date(dateString));
                }

                let imgUrl = $('.js-ImgGiftCard.slick-current img').attr('src');
                let imgCodes = imgUrl.split('/');
                let imgCode = imgCodes[imgCodes.length - 1].replace('.jpg', '');

                form = {
                    pid: pid,
                    quantity: 1,
                    uuid: uuid,
                    destinationName: destinationName,
                    destinationMail: destinationMail,
                    message: message,
                    senderName: senderName,
                    amount: amount,
                    shippingDate: dateString,
                    country: country,
                    imageCode: imgCode,
                    imgUrl: imgUrl
                };
            }

            $.spinner().start();
            if (updateProductUrl) {
                $.ajax({
                    url: updateProductUrl,
                    type: 'post',
                    context: this,
                    data: form,
                    dataType: 'json',
                    success: function (data) {
                        this.currentlyOpenedModal.close();

                        $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                        $('.promos').empty().append(data.cartModel.totals.promocodesHtml);
                        cart.updateCartTotals(data.cartModel);
                        cart.updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                        cart.updateReachedDiscounts(data.cartModel.appliedShippingDiscounts);
                        updateAvailability(data.cartModel, uuid);

                        if (isGiftCardProduct) {
                            updateGiftCardDetails(data, uuid);
                        } else {
                            updateProductDetails(data, uuid);
                        }

                        if (data.uuidToBeDeleted) {
                            $('.uuid-' + data.uuidToBeDeleted).remove();
                        }

                        cart.validateBasket(data.cartModel);

                        var $productContainer = $(e.currentTarget).closest('.product-detail');

                        if (!$productContainer.length) {
                            $productContainer = $(e.currentTarget).closest('.quickview-modal').find('.product-detail');
                        }

                        if (!$productContainer.length) {
                            $productContainer = $('.quickview-modal').find('.product-detail');
                        }

                        if (!$productContainer.length) {
                            $productContainer = $('.product-detail');
                        }

                        // For analytics after add quantity to cart
                        $('body').trigger('product:addQuantityFromCart', {
                            ...data,
                            form,
                            $productContainer
                        });

                        location.reload();
                        // $.spinner().stop();
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification(err.responseJSON.errorMessage);
                            $.spinner().stop();
                        }
                    }
                });
            }
        });
    }

    /**
     * In case of empty cart and items on wishlist, show proper content
     */
    checkWishlistItems () {
        if (!('.cart-empty').length || !$('.main-header-counter').length) {
            return;
        }
    }

    applicablePromotion () {
        var clickedQuickviewModalOnce = false;

        $('body').on('click', '.js-applicable-promotion', (e) => {
            e.preventDefault();
            if (!clickedQuickviewModalOnce) {
                clickedQuickviewModalOnce = true;
            } else {
                return true;
            }
            let requestUrl = $(e.currentTarget).data('url');
            const pid = getProductVariationGroup($(e.currentTarget).closest('.item-complete-your-promo').data('pid'), $(e.currentTarget).closest('.item-complete-your-promo').data('variation-id'));
            const promotionId = $(e.currentTarget).data('promotion-id');
            $.ajax({
                url: requestUrl,
                data: {
                    pid: pid,
                    promotionId: promotionId
                },
                method: 'GET',
                success: data => {
                    e.preventDefault();
                    var modalContent = data;
                    if (data.trim() === '') {
                        return;
                    }
                    var htmlContent = $('.cart-complete-promotion').html();
                    var modal = newModalFromString(htmlContent, false, ['layer-complete-your-promo-modal'], null, function () {
                        clickedQuickviewModalOnce = false;
                    });
                    $(modal.modalBox).addClass('new-footer-form-style rightModalAttribute container-complete-your-promo-modal');
                    modal.setContent(modalContent);
                    var promoName = $('#complete-your-promo').data('promotion-name');

                    $(modal.modalBox).find('.suggested-products-promo-message').text(promoName);
                    const topPosition = $('nav.navigation--tezenis').outerHeight() + $('.header-message').outerHeight();
                    $('.layer-complete-your-promo-modal').css('--top', topPosition);
                    modal.open();

                    $(modal.modalBox).find('.close-button').on('click', function (e) {
                        modal.close();
                        clickedQuickviewModalOnce = false;
                    });

                    if (Foundation.MediaQuery.atLeast('medium')) {
                        $('#Look').addClass('d-none');
                    } else {
                        $('#rightBar').addClass('d-none');
                    }
                    if (document.querySelectorAll('.crosssell-view.js-cross-product').length > 4) {
                        $('.container-complete-your-promo-modal .show-more').removeClass('hidden');
                    }

                    $('.container-complete-your-promo-modal .show-more').on('click', (evt) => {
                        evt.preventDefault();
                        $('.crosssell-view.js-cross-product').removeClass('hide-for-medium');
                        $('.container-complete-your-promo-modal .show-more').addClass('hide');
                        $('body').trigger('product:crossSellLoaded', {loadHead: false});
                    });

                    const $bottomContainer = $('#crossSellVariation');
                    if ($bottomContainer.hasClass('slick-initialized')) {
                        $bottomContainer.slick('destroy');
                    }
                    // $bottomContainer.slick({ // to be deleted following customer verification
                    //     slidesToShow: 1.3,
                    //     arrows: false,
                    //     dots: false,
                    //     autoplay: false,
                    //     infinite: false
                    // });

                    $('body').trigger('product:crossSellLoaded', {loadHead: true});

                    $('body').on('product:afterAddToCart', function () {
                        setTimeout(function () {
                            modal.close();
                            clickedQuickviewModalOnce = false;
                            window.location.reload();
                        }, 1300);
                    });
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
    }
    /**
     * re-renders the order totals and the number of items in the cart
     * @param {Object} data - AJAX response from the server
    */
    updateCartTotals (data, skipConfirm, skipPromoUpdate) {
        $('.number-of-items').empty().append(data.resources.numberOfItems);
        $('.shipping-total-cost').empty().append(data.totals.totalShippingCost);
        $('.tax-total').empty().append(data.totals.totalTax);
        $('.grand-total-sum').empty().append(data.totals.grandTotal);
        $('.analytics-totals').data('grandTotal', (data.totals.grandTotalValue || 0).toFixed(2));
        $('.sub-total').empty().append(data.totals.subTotal);
        $('.full-cost').empty().append(data.totals.fullTotal);
        $('.minicart-quantity').empty().append(data.numItems);
        $('.num-of-items').empty().append(('0' + data.numItems).slice(-2));

        if (data.totals.productLevelDiscountTotal.value > 0) {
            $('.product-discount').removeClass('hide');
            $('.product-discount-total').empty();
            $('.product-discount-total').append('- ' + data.totals.productLevelDiscountTotal.formatted);
        } else {
            $('.product-discount').addClass('hide');
        }
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.order-discount').removeClass('hidden');
            $('.order-discount-total').empty()
                .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
        } else {
            $('.order-discount').addClass('hidden');
        }

        if (data.totals.shippingLevelDiscountTotal.value > 0) {
            $('.shipping-discount').removeClass('hidden');
            $('.shipping-discount-total').empty().append('- ' +
                data.totals.shippingLevelDiscountTotal.formatted);
        } else {
            $('.shipping-discount').addClass('hidden');
        }

        if (data.totals.codTotalPrice) {
            $('.cod-item').removeClass('hide-cod-item');
            $('.cod-total-cost').empty().append(data.totals.codTotalPrice);
        } else {
            $('.cod-item').addClass('hide-cod-item');
        }

        if (!skipConfirm) {
            data.items.forEach(function (item) {
                $('.item-' + item.UUID).empty().append(item.renderedPromotions);
                $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);

                if (!$('.js-cart-bag-wrapper').data('just-replaced') && !skipPromoUpdate ) {
                    $('.item-complete-your-promo-wrapper-' + item.UUID).empty().append(item.renderedApplicablePromotions || '');
                    $('.item-complete-your-promo-threshold-wrapper-' + item.UUID).empty().append(item.renderedApplicablePromotionsThreshold || '');
                }

                $('.product-info.uuid-' + item.UUID).removeClass('add-margin-bottom');
                if (item.renderedApplicablePromotions || item.renderedApplicablePromotionsThreshold) {
                    $('.product-info.uuid-' + item.UUID).addClass('add-margin-bottom');
                }
            });
            $('.js-cart-bag-wrapper').data('just-replaced', false);
        }
    }

    /**
     * re-renders the approaching discount messages
     * @param {Object} approachingDiscounts - updated approaching discounts for the cart
    */
    updateApproachingDiscounts (approachingDiscounts) {
        var html = '';
        $('.approaching-discounts').empty();
        if (approachingDiscounts.length > 0) {
            approachingDiscounts.forEach(function (item) {
                html += '<div class="single-approaching-discount font-normal"> &#9757;' +
                    item.discountMsg + '</div>';
            });
        }
        $('.approaching-discounts').append(html);
    }

    /**
     * re-renders the reached discounts
     * @param {Object[]} reachedDiscounts - reached discounts for the updated cart
    */
    updateReachedDiscounts (reachedDiscounts) {
        let html = '';
        if (reachedDiscounts.length > 0) {
            let template = $('#reachedDiscountTemplate').clone();
            reachedDiscounts.forEach(function (item) {
                $('.content', template).html(item);
                html += $(template).html();
            });
        }
        $('.reached-discounts').empty().append(html);
    }

    /**
     * updates the shipping tracker state
     * @param {Object[]} freeShippingTracker - shipping tracker values
     */
    updateShippingTracker (freeShippingTracker) {
        if (freeShippingTracker.active) {
            $('.free-shipping-tracker-container .bar .filled').css('width', freeShippingTracker.percent + '%');
            $('.free-shipping-tracker-container .description-label').html(freeShippingTracker.msg);
            if (freeShippingTracker.obtained) {
                $('.free-shipping-tracker-container .icon-wrapper-complete').removeClass('hidden');
                $('.free-shipping-tracker-container .icon-wrapper-not-complete').addClass('hidden');
                $('.free-shipping-tracker-container .bar').addClass('hidden');
            } else {
                $('.free-shipping-tracker-container .icon-wrapper-not-complete').removeClass('hidden');
                $('.free-shipping-tracker-container .icon-wrapper-complete').addClass('hidden');
                $('.free-shipping-tracker-container .bar').removeClass('hidden');
            }
            $('.free-shipping-tracker-container').removeClass('hidden');
        } else {
            $('.free-shipping-tracker-container').addClass('hidden');
        }
    }

    /**
     * Checks whether the basket is valid. if invalid displays error message and disables
     * checkout button
     * @param {Object} data - AJAX response from the server
    */

    validateBasket (data) {
        if (data.valid.error) {
            if (data.valid.message) {
                var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                    'fade show" role="alert">' +
                    '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                    '<span aria-hidden="true">&times;</span>' +
                    '</button>' + data.valid.message + '</div>';
                $('.cart-error').append(errorHtml);
            } else {
                $('.cart').empty().append('<div class="row"> ' +
                    '<div class="col-12 text-center"> ' +
                    '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                    '</div> ' +
                    '</div>'
                );
                $('.number-of-items').empty().append(data.resources.numberOfItems);
                $('.minicart-quantity').empty().append(data.numItems);
                $('.minicart .popover').empty();
                $('.minicart .popover').removeClass('show');
            }
            $('.checkout-btn').addClass('disabled');
        } else {
            $('.checkout-btn').removeClass('disabled');
            $('.checkout-btn').prop('disabled', false);
            $('.error-message').addClass('hidden');
            $('#checkout-button-secure-checkout').removeClass('disabled').prop('disabled', false);
        }
    }

    shippingRecap () {
        $('body').on('click', '.shipping-methods-recap', () => {
            var modal = newModalFromSelector('methods-recap-modal-content', false, ['methods-recap-modal']);
            $(modal.modalBox).addClass('rightModalAttribute');
            modal.open();

            $(modal.modalBox).find('.recap-methods-close, .modal-close').on('click', () => {
                modal.close();
                modal.destroy();
            });
        });
    }

    mobileOpenCheckoutCTA () {
        $('body').on('click', '.fake-checkout-btn-mobile', () => {
            var modal = newModalFromSelector('checkout-buttons-container', false, ['checkout-cta-modal-mobile']);
            modal.open();
        });
    }
    openTooltip () {
        $(document).on('mouseenter focusin', '.sum-totals.pos-relative .icon-info-black', function (e) {
            if (Foundation.MediaQuery.atLeast('large')) {
                $('.tooltip.show-for-large').addClass('make-visible');
                $('.tooltip-tip.sum-totals').css({left: $('.sum-totals.pos-relative .icon-info-black').offset().left - $('.tooltip.show-for-large.sum-totals').offset().left - 19});
                $('.tooltip-tip.sum-totals').addClass('make-visible');
            }
        }).on('mouseleave focusout', '.sum-totals.pos-relative .icon-info-black', function (e) {
            $('.tooltip.show-for-large.make-visible').removeClass('make-visible');
            $('.tooltip-tip.sum-totals.make-visible').removeClass('make-visible');
        });
    }
    openTooltipMobile () {
        $('body').on('click focusin', '.shipping-estimated-arrival .icon-info-black', () => {
            var modal = newModalFromSelector('tooltip-recap-modal-content', false, ['tooltip-recap-modal']);
            if (!Foundation.MediaQuery.atLeast('large')) {
                modal.open();
                modal.attr('aria-live', 'polite');

                $(modal.modalBox).find('.modal-close').on('click', () => {
                    modal.close();
                    modal.destroy();
                });
            }
        });
        $('body').on('click focusin', '.sum-totals .icon-info-black', () => {
            var modal = newModalFromSelector('tooltip-sum-totals-modal-content', false, ['tooltip-sum-totals-modal']);
            if (!Foundation.MediaQuery.atLeast('large')) {
                modal.open();
                modal.attr('aria-live', 'polite');

                $(modal.modalBox).find('.modal-close').on('click', () => {
                    modal.close();
                    modal.destroy();
                });
            }
        });
    }
}

const cart = new Cart();
export default cart;
